import readFileAsBuffer from "./readFileAsBuffer.js";

export const hashData = async (buffer, checksum) => {
  const { default: CryptoJS } = await import("crypto-js");

  if (checksum === "MD5") {
    return CryptoJS.MD5(buffer).toString();
  }

  if (checksum === "SHA-1") {
    return CryptoJS.SHA1(buffer).toString();
  }

  if (checksum === "SHA-256") {
    return CryptoJS.SHA256(buffer).toString();
  }

  return null;
};

const calculateFileHash = async (file) => {
  const buffer = await readFileAsBuffer(file);
  const md5Hash = await hashData(buffer, "MD5");
  const sha1Hash = await hashData(buffer, "SHA-1");
  const sha256Hash = await hashData(buffer, "SHA-256");
  return { md5Hash, sha1Hash, sha256Hash };
};

export default calculateFileHash;
